import { v4 as uuidv4 } from 'uuid';
import SubmitButton from "../../../../../components/base/forms/submit-button";
import DOMHelper from "../../../../../lib/dom-helper";
import {animate} from "../../../../../lib";
import Api from "../../../../../lib/api";
import {AnalyticsService} from "../../../../../services/analytics-service";

export default class ResultPage {
	constructor($root, mainController) {
		/* Elements */
		this.$root = $root;
		this.$shuffle = this.$root.closest('.shuffle');
		this.$resultPage = this.$root.querySelector('.quiz-page.-result');
		this.$pageBody = this.$resultPage.querySelector('.quiz-result');
		this.$answersNum = this.$root.querySelector('.svg-spinner_value');
		this.$message = this.$root.querySelector('.quiz-result_description');
		this.$tip = this.$root.querySelector('.quiz-result_tip');
		this.$resultBtn = this.$root.querySelector('.quiz-result_btn');
		this.$svg = this.$root.querySelector('.quiz-result_spinner');
		this.$circle = this.$svg.querySelector('.svg-spinner_circle');
		this.$consultationBtn = document.getElementById('quizResultConsultation');

		this.isInitialized = false;
		this.animationDelay = 500;
		this.correct = null;
		this.resultCount = null;
		this.resultGrade = null;
		this.otherQuizConfig = null;

		/* Components */
		this.mainController = mainController;
		this.submitBtnController = new SubmitButton({
			$root: this.$resultBtn,
			endWithState: 'ready'
		});

		this.submitStatus = null;
	}

	init(switchPageCallback) {
		if (!this.isInitialized) {
			ResultPage.prototype.switchPage = switchPageCallback;
		}

		this.bootstrap();
	}

	bootstrap() {
		this.circumference = +this.$circle.getAttribute('r') * 2 * 3.14;
		this.$circle.style.strokeDasharray = this.circumference;
		this.$circle.style.strokeDashoffset = this.circumference;

		if (this.mainController.isUserAuthenticated) {
			this.completeQuiz();

			this.mainController.unregisterEvent('consultation');
			this.mainController.registerEvent('consultation', 'click', this.$consultationBtn, e => {
				this.switchPage();
			});
		}

		this.correct = this.mainController.totalCorrect;
		this.resultCount = this.correct / this.mainController.getTotalQuestions();

		this.setResultGrade();
		this.setupResult();
	}

	completeQuiz() {
		let cachedUserData = {};
		const storage = costorage.get('h_formValues');

		if (storage) {
			cachedUserData = JSON.parse(storage);
		}

		const lmsUserData = this.mainController.sl.userDataService.lmsUserData;
		const conversionId = uuidv4();
		const owoxUserId = costorage.get('ouid');
		const quizData = this.mainController.getResult();
		let formData = {
			type: 'quiz-consultation',
			city: craft.env.cityId,
			course: craft.page.courseDirectoryId,
			conversionId,
			fbp: costorage.get('_fbp') ? costorage.get('_fbp') : null,
			fbc: costorage.get('_fbc') ? costorage.get('_fbc') : null,
			referrer: location.href,
			email: lmsUserData.email || cachedUserData.email,
			tel: lmsUserData.phone || cachedUserData.tel,
			name: lmsUserData.first_name || cachedUserData.name,
			ratio: quizData.ratio,
			answers: quizData.questionList,
			passGrade: quizData.quizPassGrade,
			quizId: this.mainController.config.entryId,
			quizTitle: this.mainController.getQuizTitle()
		};

		formData = Api.updateAndReturnDataWithUtmTags(formData);

		if (owoxUserId) {
			formData.owoxUserId = owoxUserId;
		}

		if (this.mainController.config.extraSlug) {
			formData["quizExtraSlug"] = this.mainController.config.extraSlug;
		}

		if (this.mainController.sl.courseLang) {
			formData.courseLang = this.mainController.sl.courseLang;
		}

		AnalyticsService.sendEvent('online_test_form', {
			formId: 'quiz',
			phone: lmsUserData.phone || cachedUserData.tel,
			email: lmsUserData.email || cachedUserData.email,
			conversion_id: conversionId
		});

		Api.post(`${Api.restSiteUrl}/2.0/courses/registration`, formData).catch((err) => {
			console.error('Quiz:', err);
		});

		this.mainController.finishQuiz();
	}

	setResultGrade() {
		const resultGrade = this.mainController.getResultGrade();
		if (
			resultGrade === 'excellent' ||
			resultGrade === 'average' ||
			resultGrade === 'poor'
		) {
			this.resultGrade = resultGrade;
		} else {
			console.error('Invalid result grade.');
		}

		if (resultGrade && resultGrade !== 'poor') {
			window.dispatchEvent(new Event('SET_QUIZ_PASSED_ON_BUY_LINK'));
		}
	}

	setupResult() {
		this.animateSpinner();
		this.setResultPageColorClass();
		this.writeCircularDiagramResultCount();
		this.setupResultMessage();
		this.setupResultTip();
		this.setupResultBtn();
	}

	animateSpinner() {
		const offset = this.circumference * (1 - this.resultCount);
		const diff = this.circumference - offset;

		setTimeout(() => {
			animate({
				timing: (t) => t,
				draw: (progress) => {
					this.$circle.style.strokeDashoffset = this.circumference - (diff * progress);
				},
				duration: 300
			});
		}, this.animationDelay);
	}

	setResultPageColorClass() {
		this.$resultPage.classList.remove('-excellent', '-average', '-poor');
		this.$pageBody.classList.remove('-excellent', '-average', '-poor');
		this.$pageBody.classList.add('-' + this.resultGrade);
		this.$resultPage.classList.add('-' + this.resultGrade);
	}

	writeCircularDiagramResultCount() {
		this.$answersNum.textContent = this.correct;
	}

	setupResultMessage() {
		const resultMessages = {
			excellent: () => {
				this.writeCircularDiagramResultMessage(craft.localization.quiz.main[0]);
			},
			average: () => {
				this.writeCircularDiagramResultMessage(craft.localization.quiz.main[1]);
			},
			poor: () => {
				this.writeCircularDiagramResultMessage(craft.localization.quiz.main[2]);
			}
		};
		resultMessages[this.resultGrade]();
	}

	setupResultTip() {
		let text, isConsultation, isSecondQuiz;
		const userData = this.mainController.getUserData();
		if (userData) {
			isConsultation = userData['type'] === 'quiz-consultation';
			isSecondQuiz = userData['fromStorage'];
		}

		if (this.resultGrade !== 'poor') {
			if (
				this.mainController.isFirstSession &&
				!isSecondQuiz &&
				this.mainController.isMultiple
			) {
				text = craft.localization.quiz.sub[2];
			} else if (
				(
					(!this.mainController.isFirstSession && this.mainController.isOtherQuizResult) ||
					(!this.mainController.isMultiple)
				) && isConsultation
			) {
				text = craft.localization.quiz.sub[0];
			}
		}

		this.writeCircularDiagramResultTip(text);
	}

	/* Result Btn Methods */
	setupResultBtn() {
		const otherQuizResult = this.mainController.getOtherQuizResult();
		if (
			this.mainController.isFirstSession ||
			!this.mainController.isOtherQuizResult ||
			this.resultGrade === 'poor' ||
			otherQuizResult === 'poor'
		) {
			this.showResultBtn();
		}
	}

	showResultBtn() {
		const userData = this.mainController.getUserData();

		this.dropResultBtnEventHandlers();
		this.submitBtnController.refresh();

		if (this.resultGrade === 'poor') {
			this.setupResultBtnTryAgainQuiz();
		} else if (userData && userData.hasOwnProperty('fromStorage') && !this.mainController.isUserAuthenticated) {
			this.setupResultBtnGetConsultation();
		} else if (this.mainController.isMultiple) {
			this.setupResultBtnStartOtherQuiz();
		} else {
			DOMHelper.hide(this.$resultBtn);
		}
	}

	dropResultBtnEventHandlers() {
		this.mainController.unregisterEvent('getConsultation');
		this.mainController.unregisterEvent('tryAgainQuiz');
		this.mainController.unregisterEvent('startOtherQuiz');
	}

	setupResultBtnGetConsultation() {
		this.writeResultBtn(craft.localization.quiz.multiple.getConsultation);
		this.mainController.registerEvent('getConsultation', 'click', this.$resultBtn, e => {
			e.preventDefault();
			this.getConsultation();
		});
		DOMHelper.show(this.$resultBtn);
	}

	setupResultBtnTryAgainQuiz() {
		this.writeResultBtn(craft.localization.quiz.multiple.tryAgain);
		this.mainController.registerEvent('tryAgainQuiz', 'click', this.$resultBtn, e => {
			e.preventDefault();
			this.tryAgainThisQuiz();
		});
	}

	setupResultBtnStartOtherQuiz() {
		const otherQuizBtnLabel = this.mainController.otherQuizConfig.buttonLabel;

		this.writeResultBtn(craft.localization.quiz.multiple.try + ' ' + otherQuizBtnLabel);
		this.mainController.registerEvent('startOtherQuiz', 'click', this.$resultBtn, e => {
			e.preventDefault();
			this.startOtherQuiz();
		});
	}

	writeCircularDiagramResultMessage(text) {
		this.$message.textContent = text;
	}

	writeCircularDiagramResultTip(text) {
		if (text) {
			this.$tip.textContent = text;
		} else {
			DOMHelper.hide(this.$tip);
		}
	}

	writeResultBtn(text) {
		const $textField = this.$resultBtn.querySelector('.btn-submit_common');
		$textField.textContent = text;
	}

	startOtherQuiz() {
		this.startNewQuiz(this.mainController.otherQuizConfig);
	}

	tryAgainThisQuiz() {
		this.startNewQuiz(this.mainController.config);
	}

	getConsultation() {
		this.sendConsultationRequest();
		this.submitBtnController.startAnimation(() => this.submitStatus);
	}

	sendConsultationRequest() {
		const userData = this.mainController.getUserData();
		const formData = Object.assign({}, userData);
		delete formData['fromStorage'];
		formData['type'] = 'consultation';

		Api.post(`${Api.restSiteUrl}/2.0/courses/registration`, formData)
			.then(() => {
				this.submitStatus = 'ok';
			}).catch((err) => {
				this.submitStatus = 'error';
				console.error('Quiz:', err);
			});
	}

	startNewQuiz(config) {
		let currentPageNum = 2;
		this.mainController.init(isStorage => {
			if (isStorage) {
				currentPageNum = 3;
			}
			this.switchPage('initial', currentPageNum);
			setTimeout(() => {
				this.mainController.toggleProgressOverlay('hide');
			}, 1000);
		}, config, true);
	}
}